<template>
    <div class="speech-bubble">


        <slot />

    </div>
</template>

<script>
    export default {
        name: "SpeechBubble"
    }
</script>

<script setup>

    // const props = defineProps({
    //     handleClickPrev : {
    //         type: Function,
    //         default: null
    //     },
    //     handleClickNext : {
    //         type: Function,
    //         default: null
    //     },
    //
    // });

</script>
